import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSessionId, fetchMyHouseholds, saveActiveHousehold } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) {
            nav("/login", { replace: true });
            return;
        }
        const sid = decodeURIComponent(m[1]);
        const pendingCode = sessionStorage.getItem("milo_pending_code");
        (async () => {
            try {
                const u = await exchangeSessionId(sid);
                setUser(u);
                window.history.replaceState(null, "", window.location.pathname);

                // Fast path: try to skip the picker screen.
                if (pendingCode) {
                    sessionStorage.removeItem("milo_pending_code");
                    nav(`/picker?code=${pendingCode}`, { replace: true });
                    return;
                }
                const list = await fetchMyHouseholds();
                if (list.length === 1) {
                    // Single household — skip picker, go straight in.
                    const e = list[0];
                    saveActiveHousehold({
                        household_id: e.household.id,
                        household_name: e.household.name,
                        household_code: e.household.code,
                        member_id: e.member.id,
                        member_name: e.member.name,
                    });
                    nav("/app", { replace: true });
                    return;
                }
                // 0 or 2+ households → picker
                nav("/picker", { replace: true });
            } catch (e) {
                toast.error("Sign-in failed. Try again.");
                nav("/login", { replace: true });
            }
        })();
    }, [nav, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
                <div className="flex gap-2 justify-center mb-4">
                    <span className="w-3 h-3 rounded-full bg-[#0D2A1B] animate-bounce" />
                    <span
                        className="w-3 h-3 rounded-full bg-[#0D2A1B] animate-bounce"
                        style={{ animationDelay: "120ms" }}
                    />
                    <span
                        className="w-3 h-3 rounded-full bg-[#0D2A1B] animate-bounce"
                        style={{ animationDelay: "240ms" }}
                    />
                </div>
                <div className="font-heading text-lg">Signing you in…</div>
            </div>
        </div>
    );
}
